import React, { useState } from "react";
import newsLetterImage from "assets/images/newsletter.svg";
import closeImage from "assets/images/close.svg";
import Button from "components/ReusableComponents/Button/Button";
import axios from "axios";
import ThankyouPopup from "components/Thankyou";

function NewsLetterPopup({ isOpen, setIsOpen, data }) {
  const [email, setEmail] = useState("");
  const [showThankyou, setShowThankyou] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();

    const webhookUrl =
      "https://hooks.slack.com/services/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";
    const postData = {
      text: `Email: ${email}`,
    };

    try {
      const response = await axios.post(webhookUrl, JSON.stringify(postData));
      if (response.status === 200) {
        setEmail("");
        setShowThankyou(true);
        setTimeout(() => {
          setShowThankyou(false);
          setIsOpen(false);
        }, 2000);
      }
    } catch (error) {
      console.error(error);
    }
  };

  if (!isOpen) {
    return <></>;
  }

  return (
    <div className="fixed inset-0  grid place-items-center z-[9999] px-4 lg:px-0">
      <div
        className="backdrop-blur-sm bg-white/30 fixed inset-0"
        onClick={() => setIsOpen(false)}
      ></div>
      <div
        className={`${
          showThankyou && "hidden"
        } bg-goldLight rounded-md px-5 pt-20 pb-16 relative max-w-3xl flex flex-col sm:flex-row items-center sm:items-end gap-6`}
      >
        <img
          src={closeImage}
          alt="close-popup"
          className="absolute top-2 right-2 cursor-pointer"
          onClick={() => setIsOpen(false)}
        />
        <div className="border-2 w-48 h-52 overflow-hidden">
          <img
            src={newsLetterImage}
            alt="newsletter"
            className="w-full h-full max-w-full"
          />
        </div>
        <div>
          <h2 className="text-2xl sm:text-4xl text-black text-center sm:text-left xs:font-cairo pb-2">
            Loved Our Blog Posts
          </h2>
          <p className="text-lg sm:text-xl text-black text-center sm:text-left xs:font-cairo">
            Subscribe To Get Daily Updates Directly To Your Inbox
          </p>
          <form
            onSubmit={onSubmit}
            className="flex flex-col sm:flex-row gap-3 pt-5"
          >
            <input
              type="email"
              placeholder="Enter your Email"
              required
              className="bg-white text-black border border-primary outline-none rounded-lg w-full px-4 py-2 block"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Button
              variant="primary"
              title="Subscribe"
              className="rounded-lg"
            />
          </form>
        </div>
      </div>
      {showThankyou && (
        <ThankyouPopup
          setShowThnakyou={setShowThankyou}
          title="Subscribed Successfully! "
          descripition="Thanks for subscribing to our newsletter"
          style="md:px-0 px-[70px]"
        />
      )}
    </div>
  );
}
export default NewsLetterPopup;
